import React, { ReactNode } from "react";

import { classNames } from "@assets/utilities/classNameUtilities";

interface QuoteListItemProps {
  /** Accentuated element of the list item. */
  header?: ReactNode;
  /** Less accentuated element of the list item. */
  description?: ReactNode;
  /** Override or extend the style applied to the list item. */
  className?: string;
}

const QuoteListItem = ({
  className,
  description,
  header,
}: QuoteListItemProps) => {
  return (
    <li className={classNames("mb-2 flex gap-0.5", className)}>
      <span className="text-neutral-1000">{header}</span>
      <span>•</span>
      <span className="text-neutral-700">{description}</span>
    </li>
  );
};

export default QuoteListItem;
